import { render, staticRenderFns } from "./WidgetPickerDialog.vue?vue&type=template&id=e7ac779c"
import script from "./WidgetPickerDialog.vue?vue&type=script&lang=js"
export * from "./WidgetPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./WidgetPickerDialog.vue?vue&type=style&index=0&id=e7ac779c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports